import { Button, Checkbox, TextInput,CheckboxGroup } from "@carbon/react";
import { useNavigate } from "react-router-dom";
import { postSubmitLogin } from "../../services/services";

const Login = () => {  
  const navigate = useNavigate();

  const submitLogin = () => {
    let username = document.getElementById('user-name-input').value;
    let password = document.getElementById('password-input').value;

    postSubmitLogin(username,password)
    .then(resp => {
      let path = resp.redirectPath;
      if(path == '')
        return
      navigate("/"+path)
    });
  }

  const fieldsetCheckboxProps = () => ({
    className: 'some-class',
    legendText: ''
  });
  return (
    <>
      <div
        className="ds-offset-xs-1 ds-pad-t-b-2 ds-pad-l-r-xs-1 ds-pad-l-md-2 ds-pad-r-md-0"
        role="main"
      >
        <div className="ds-row">
          <div className="ds-col-10">
            <p
              className="cs-select-login-provider-instructions title"
              id="title"
            >
              Sign in with your w3id credentials
            </p>
          </div>
        </div>
        <div className="ds-row">
          <div className="ds-col-10 col-lg-6 col-md-8 col-sm-10">
            <p className="subtitle" id="subtitle">
              Use your w3id and password
            </p>
          </div>
        </div>
      </div>
      <div className="login-main ds-offset-xs-1 ds-pad-b-2 ds-pad-l-r-xs-1 ds-pad-l-md-2 ds-pad-r-md-0 ds-col-xs-10 ds-col-sm-8 ds-col-md-6 ds-col-lg-5 ds-col-xl-4">
        
          <input type="hidden" name="typeOfCompany" id="idTypeOfCompany" />
          <input type="hidden" name="operation" value="verify" />
          <label className="label ds-hide" id="user-name-label">
            IBM email address (e.g. jdoe@ibm.com)
          </label>
          <div className="ds-input-container">
            <div id="login-error-message">
              <p
                id="login-error-text"
                className="ds-text-contextual-red-4 login-error-text"
              ></p>
            </div>
            <TextInput
              type="email"
              name="j_username"
              tabIndex="0"
              className="user-name ds-input"
              id="user-name-input"
              placeholder="IBM email address (e.g. jdoe@ibm.com)"
              aria-label="IBM email address (e.g. jdoe@ibm.com)"              
              carbon-text-input="false"
            ></TextInput>
          </div>
          <div className="ds-input-container">
            <label id="password-label" className="ds-hide">
              Password
            </label>
            <TextInput
              type="password"
              name="j_password"
              tabIndex="0"
              className="password ds-input"
              id="password-input"
              placeholder="Password"
              aria-label="Password"
              autocomplete="off"
              
            ></TextInput>
            <span
              id="showHidePw"
              className="ds-clickable ds-icon-medium ds-icon-view ds-icon-pull-right"
              tabIndex="0"                            
            ></span>
            <p
              className="ds-text-contextual-red-4 ds-mar-t-1 ds-pad-l-0_5"
              id="statetext"
            ></p>
            <div id="forgotPassword" className="ds-col-12">
              <a
                href="https://w3idprofile.sso.ibm.com/password/createpwd_lookup_otp.wss"
                className="ds-clickable"
                id="w3id-link"
                role="link"
                tabIndex="0"
              >
                Forgot password?
              </a>
            </div>
          </div>
          <div className="ds-input-container ds-mar-b-2">
            <CheckboxGroup {...fieldsetCheckboxProps()}>
              <Checkbox              
                id="chkbox_w3rememberme"                
                labelText={`Remember my email address`}
              />            
            </CheckboxGroup>
          </div>
          <div className="ds-button-group-h ds-row" id="submit">
            <Button
              className="ds-clickable ds-button ds-col-xs-8 ds-col-sm-5 ds-col-xl-4 ds-mar-b-1 ds-mar-b-lg-0"
              aria-pressed="false"
              id="login-button"
              value="login"
              type="submit"
              role="button"
              onClick={() => submitLogin()}
            >
              Sign in
            </Button>
          </div>
        
        <div className="ds-hr ds-mar-t-b-1"></div>
        <p id="otherOptions" className="ds-pad-b-1">
          View other{" "}
          <a
            className="ds-clickable"
            aria-pressed="false"
            id="back-button"
            value="back"
            type="link"
            role="link"
            
          >
            sign in methods
          </a>
        </p>
        <p id="learnMore">
          We’re enhancing w3id.{" "}
          <a
            className="ds-clickable"
            aria-pressed="false"
            id="directions-link"
            role="link"
            type="link"
            tabIndex="0"
            target="_blank"
            href="https://ibm.biz/w3id-passwordless"
          >
            Learn more
          </a>
        </p>
      </div>
    </>
  );
};

export default Login;
